import type { ReactNode } from 'react';

// Resumen del pedido al pie de Nueva solicitud (admin y cliente): por cada
// turno, quiénes fueron elegidos por nombre y cuántos salen por asignación
// automática, con su horario. Pedido de Fernando (14/07/2026): con varios
// turnos y horarios distintos, ver clarito qué se está pidiendo antes de crear.

export interface ResumenTurnoItem {
  categoria: string;
  /** Número del turno dentro de la categoría; null si es el único. */
  numeroTurno: number | null;
  rango: string;
  /** Nombres de las personas elegidas a dedo. */
  elegidas: string[];
  /** Cupos restantes que asigna el motor. */
  autos: number;
}

export function ResumenPedido({ items, total }: { items: ResumenTurnoItem[]; total: number }): ReactNode {
  if (items.length === 0) return null;
  return (
    <div className="mt-4 rounded-xl border border-contorno-var bg-superficie-100/40 p-4">
      <h4 className="mb-3 text-xs font-bold uppercase tracking-wide text-neutro-500">Resumen del pedido</h4>
      <ul className="space-y-3">
        {items.map((it, i) => (
          <li key={i}>
            <p className="text-sm font-semibold text-neutro-800">
              {it.categoria}
              {it.numeroTurno != null && <span className="font-medium text-neutro-500"> · Turno {it.numeroTurno}</span>}
              <span className="ml-1.5 text-xs font-semibold text-primario-400">{it.rango}</span>
            </p>
            <ul className="mt-1 space-y-0.5">
              {it.elegidas.map((n) => (
                <li key={n} className="flex items-center gap-1.5 text-xs text-neutro-700">
                  <span className="font-bold text-primario-400">✓</span>
                  <span>{n}</span>
                </li>
              ))}
              {it.autos > 0 && (
                <li className="flex items-center gap-1.5 text-xs text-neutro-500">
                  <span>⚡</span>
                  <span>{it.autos} por asignación automática</span>
                </li>
              )}
            </ul>
          </li>
        ))}
      </ul>
      <div className="mt-3 flex items-center justify-between border-t border-contorno-var pt-2.5">
        <span className="text-sm text-neutro-500">Total</span>
        <span className="text-lg font-bold text-neutro-800">{total} persona{total !== 1 ? 's' : ''}</span>
      </div>
    </div>
  );
}
